import React from "react";
import TextWithTooltip from "./TextWithTooltip";

/**
 * Card de fluxo para exibir uma sequência de entidades (ex: origem → destino).
 *
 * @param {Object} props
 * @param {Array<Object>} props.flowData - Lista de itens do fluxo
 * @param {string} props.flowData[].name - Nome principal exibido
 * @param {string} [props.flowData[].description] - Texto secundário (opcional)
 * @param {string} [props.flowData[].logo] - URL da imagem/logo (opcional)
 *
 * @example
 * <CardFlow
 *   flowData={[
 *     { name: "Dicico", description: "SODIMAC CD CUMBICA", logo: "url_logo" },
 *     { name: "Quartzolit", description: "SAINT-GOBAIN" }
 *   ]}
 * />
 */
const CardFlow = ({ flowData = [], enableTooltip = true }) => {
  const flowItems = React.useMemo(() => {
    return Array.isArray(flowData) ? flowData : [];
  }, [flowData]);

  if (flowItems.length === 0) return null;

  const formatName = (name = "") => {
    const formatted =
      name.charAt(0).toUpperCase() + name.toLowerCase().slice(1);

    return name.length > 11 ? `${formatted.slice(0, 11)}...` : formatted;
  };

  return (
    <div className="card-flow-dynamic-container d-flex align-items-center justify-content-center gap-3">
      {flowItems.map((item, index) => {
        // ✅ PADRÃO DEFINIDO
        const name = item?.name ?? "";
        const description = item?.description ?? "";
        const logo = item?.logo ?? null;

        return (
          <React.Fragment key={`${name}-${index}`}>
            <div className="d-flex align-items-center gap-2">
              {logo ? (
                <div className="card-flow-logo-wrapper">
                  <img src={logo} alt={name} className="card-flow-logo" />
                </div>
              ) : (
                <i className="far fa-user-circle user-photo-label" />
              )}

              <div className="flow-item d-flex flex-column" title={name}>
                {enableTooltip ? (
                  <TextWithTooltip
                    id={index}
                    textFull={name}
                    text={formatName(name)}
                    classname="card-flow-name"
                  />
                ) : (
                  <span className="card-flow-name" title={name}>{formatName(name)}</span>
                )}

                {description && (
                  <span className="card-flow-size text-muted small">
                    {description}
                  </span>
                )}
              </div>
            </div>

            {index < flowItems.length - 1 && (
              <i className="bx bx-right-arrow-alt card-flow-arrow"></i>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CardFlow;
